import React, { useEffect, useRef, useState } from 'react'
import cancelIcon from './../../../../assets/images/adminPanel/icons8-cancel.svg'

const DropdownItem = ({ itemName, deleteText, updateText, disabled }) => {
	const [isValidInput, setIsVaildInput] = React.useState(true)
	const [text, setText] = useState(itemName)
	const textAreaRef = useRef(null)
	const [height, setHeight] = useState(0)

	useEffect(() => {
		resizeTextbox(textAreaRef.current)
	}, [])

	const onInputChange = (e) => {
		setText(e.target.value)
		resizeTextbox(e.target)
	}

	const resizeTextbox = (textbox) => {
		setHeight(textbox.scrollHeight)
	}

	const handleKeyDownEvent = (e) => {
		if (e.key !== 'Enter') return
		e.preventDefault()
		document.activeElement.blur()
		updateEntry()
	}

	const onLoseFocus = () => {
		updateEntry()
	}

	const updateEntry = () => {
		if (text === itemName) return
		const didUpdateText = updateText(itemName, text)
		setIsVaildInput(didUpdateText)
	}

	return (
		<div className='dropdownItem'>
			<textarea
				ref={textAreaRef}
				type='text'
				className='dropdownItemText'
				value={text}
				onChange={onInputChange}
				onBlur={onLoseFocus}
				style={{
					border: isValidInput ? 'none' : 'red 2px solid',
					height: height,
				}}
				onKeyDown={handleKeyDownEvent}
				rows={1}
				disabled={disabled}
			/>
			<button
				className='removeItemButton'
				onClick={() => deleteText(itemName)}
				disabled={disabled}
			>
				<img src={cancelIcon} />
			</button>
		</div>
	)
}

export default DropdownItem
